<template>
  <div class="d-flex align-center">
    <div
      v-if="mostrarIcones"
      class="mr-2"
    >
      <icons
        :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
        :vertical="true"
        @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
        @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
      />
    </div>

    <div>
      <v-card
        outlined
        class="d-flex flex-column"
      >
        <v-card-title class="pa-3">
          {{ label }}
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0">
          <e-signature
            :permitir-edicao="permitirEdicaoAssinatura"
            :signature-url="state.url"
            @input-changed="$emit('input-changed', { value: $event })"
          />
        </v-card-text>
      </v-card>

      <v-alert
        v-if="componenteAssinaturaOptions && componenteAssinaturaOptions.fetchSignature"
        type="info"
        color="primary"
        text
        dense
        outlined
        dismissible
        transition="scale-transition"
        class="mt-2 mb-0"
      >
        <h4
          class="d-flex justify-center"
        >
          {{ componenteAssinaturaOptions.mensagemDeAlerta }}
        </h4>
      </v-alert>
    </div>
  </div>
</template>

<script>
import { computed, ref, watchEffect } from '@vue/composition-api'
import Icons from './Icons.vue'
import ComponenteBase from './ComponenteBase.vue'
import ComponenteAssinaturaOptions from '@/models/props/ComponenteAssinaturaOptions'
import DocumentoService from '@/services/modules/DocumentoService'
import ESignature from '@/components/assinatura/ESignature.vue'

export default {
  components: {
    Icons,
    ESignature,
  },

  extends: ComponenteBase,

  props: {
    componenteAssinaturaOptions: {
      type: ComponenteAssinaturaOptions,
      default: null,
    },
  },

  setup(props) {
    const state = ref({ ticketId: 0, componenteId: 0, url: null })

    async function loadSignature(ticketId, componenteId) {
      if (!ticketId || !componenteId) return
      const data = await DocumentoService.getFormularioComponentAnexos(ticketId, componenteId)
      state.value.url = data.pop()?.url ?? null
    }

    watchEffect(async () => {
      if (!props.componenteAssinaturaOptions) return

      const { fetchSignature, ticketId, componenteId } = props.componenteAssinaturaOptions

      if (!fetchSignature) {
        state.value = { ticketId: 0, componenteId: 0, url: null }
        return
      }

      if (state.value.ticketId === ticketId && state.value.componenteId === componenteId) {
        return
      }

      state.value.ticketId = ticketId
      state.value.componenteId = componenteId

      await loadSignature(state.value.ticketId, state.value.componenteId)
    })

    const permitirEdicaoAssinatura = computed(() => !props.componenteAssinaturaOptions?.fetchSignature && !state.value.url)

    return {
      state,
      permitirEdicaoAssinatura,
    }
  },
}
</script>
